import PopupsDesktop from '../popups-desktop/popups-desktop';
import PopupsMobile from '../popups-mobile/popups-mobile';

export default new class Cart {
    constructor() {
        this.cartPage = '[data-cart-page]';

        if (!$(this.cartPage).length) return;

        this.btnSubmit = '[data-valid-form]';
        this.cartOrderForm = '[data-cart-order-form]';
        this.cartOrderFormArea = '[data-cart-order-form-area]';

        this.cartItem = '[data-cart-item]';
        this.cartItemArea = '[data-cart-item-area]';
        this.cartItemPrice = '[data-cart-item-price-val]';
        this.cartItemOldPrice = '[data-cart-item-price-old]';
        this.cartItemName = '[data-cart-item-name]';
        this.cartItemArticle = '[data-cart-item-article]';
        this.paymentRadio = '[data-cart-order-form-payment-radio]';
        this.paymentLabelCancel = '[data-cart-order-form-payment-label-cancel]';
        this.paymentRadioCancel = '[data-cart-order-form-payment-radio-cancel]';
        this.preloader = '[data-preloader]';

        this.classShow = '_show';

        this.eventsHandler()
    }

    eventsHandler() {
        let $doc = $(document);

        $doc.on('click', this.btnSubmit, (e) => {
            e.preventDefault();
            let $btnSubmit = $(e.currentTarget);
            if (!simpleValid($btnSubmit)) return;

            this.makeOrder($btnSubmit);
        });

        $doc.on('click', this.paymentRadio, () => {
            this.showCancelPaymentType();
        });

        $doc.on('click', this.paymentRadioCancel, () => {
           this.hideCancelPaymentType();
        })

    }

    hideCancelPaymentType() {
        let labelCancel = document.querySelector(this.paymentLabelCancel);

        labelCancel.classList.remove(this.classShow);
    }

    showCancelPaymentType() {
        let labelCancel = document.querySelector(this.paymentLabelCancel);

        labelCancel.classList.add(this.classShow);
    }

    makeOrder($btnSubmit) {
        this.collectData($btnSubmit);
        this.clearOrderForm();

        // off focus from eny element,
        // fix bug with validation if
        // user used 'Enter' button
        document.activeElement.blur();
    }

    collectData($btnSubmit) {
        this.sendData({
            item: this.collectItemsData(),
            form: this.collectFormData($btnSubmit)
        },$btnSubmit)
    }

    /**
     * Clear all values of cart areas
     */
    clearOrderForm() {
        $(this.cartOrderFormArea).val('');
    }

    /**
     * Collect total items data in array
     */
    collectItemsData() {
        let arItems = $(this.cartItem),
            itemsData = [];

        arItems.map((i, item) => {
            itemsData.push(this.collectItemData($(item)));
        });

        return itemsData;
    }

    /**
     * Collect item-cart data to object
     * @param {jquery} $cartItem
     * @returns {{}}
     */
    collectItemData($cartItem) {
        return {
            id: $cartItem.data('cart-item-id'),
            old_price: $cartItem.find(this.cartItemOldPrice).text(),
            quantity: $cartItem.find(this.cartItemArea).val(),
            price: $cartItem.find(this.cartItemPrice).text(),
            name: $cartItem.find(this.cartItemName).data('cart-item-name'),
            article: $cartItem.find(this.cartItemArticle).data('cart-item-article')
        };
    }

    collectFormData($btnSubmit) {
        let $form = $btnSubmit.closest(this.cartOrderForm),
            arAreas = $form.find(this.cartOrderFormArea),
            formData = {};

        arAreas.each((i, item) => {
            if (item.type === 'radio' && !item.checked) return;
            formData[$(item).attr('name')] = $(item).val();
        });

        return formData;
    }

    sendData(data, $btnSubmit) {

        $(this.preloader).addClass(this.classShow);

        $.request('onMakeOrder', {
            data: {'data': data},
            complete: function(response) {
                let data = response.responseJSON;

                $(this.preloader).removeClass(this.classShow);
                PopupsDesktop.openOrderPopup($btnSubmit, data);
                PopupsMobile.openOrderPopup($btnSubmit, data);

            }
        })
    }
}
